import React from 'react';
import NotApprovedPageContainer from './containers/NotApprovedPageContainer';
import '../../../css/moderation/moderation.scss';

function ModerationPage(): JSX.Element {
  return <NotApprovedPageContainer />;
}

export default ModerationPage;
